//@flow
export default {
  NETBOOK: 1024,
  TABLET: 768,
  MOBILE: 568,
};
